import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import MotionPath from 'gsap/MotionPathPlugin'
import '@lottiefiles/lottie-player'

Alpine.plugin(collapse)
window.Alpine = Alpine

// submarine exists
const is_home = document.getElementById('submarine') !== null

if (is_home) {
    gsap.registerPlugin(ScrollTrigger)
    gsap.registerPlugin(MotionPath)

    // Starfish animation
    const starfish_timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '#starfish-path',
            start: 'top top',
            end: 'bottom top',
            scrub: true,
            ease: 'power2.out',
            duration: 2,
        }
    })

    const starfish = document.getElementById('starfish')
    const start_positioner = document.getElementById('starfish-path-start')
    const start_coordinates = start_positioner.getBoundingClientRect()
    const middle_positioner = document.getElementById('starfish-path-middle')
    const middle_coordinates = middle_positioner.getBoundingClientRect()
    const end_positioner = document.getElementById('starfish-path-end')
    const end_coordinates = end_positioner.getBoundingClientRect()
    const start_middle_delta = MotionPath.convertCoordinates(start_positioner, middle_positioner, { x: 0, y: 0 })
    const start_end_delta = MotionPath.convertCoordinates(start_positioner, end_positioner, { x: 0, y: 0 })

    const start = {
        x: 0,
        y: 0,
        scale: 1,
        rotation: 0,
    }

    const middle = {
        x: -start_middle_delta.x,
        y: -start_middle_delta.y,
        scale: middle_coordinates.width / start_coordinates.width,
        rotation: 50,
    }

    const end = {
        x: -start_end_delta.x,
        y: -start_end_delta.y,
        scale: end_coordinates.width / start_coordinates.width,
        rotation: 120,
    }

    const motionPath = {
        path: [start, middle, end],
        curviness: 2,
    }

    if (window.starfish_animation_enabled) {
        starfish_timeline.to(starfish, {
            motionPath: motionPath,
        })
    }

    // Light to dark
    gsap.timeline({
        scrollTrigger: {
            trigger: '#light-to-dark',
            start: 'top top',
            end: '+=1000',
            scrub: 1,
        },
    })
        .to('html', {
            '--color-background': '20 20 20',
            '--color-foreground': '255 255 255',
        })

    Alpine.data('scrollbar', () => ({
        sections: [],
        init() {
            let sections = document.querySelectorAll('[data-section-name]')

            setTimeout(() => {
                sections.forEach((section) => {
                    // Get the name of the section
                    let sectionName = section.getAttribute('data-section-name')

                    // Get the ID of the section
                    let sectionId = section.getAttribute('data-section-id')

                    // Get the position of the section
                    let sectionTop = section.getBoundingClientRect().top

                    let sectionMiddlePercent = sectionTop / document.body.clientHeight * 100 + '%'

                    this.sections.push({
                        name: sectionName,
                        id: sectionId,
                        top: sectionTop,
                        style: 'top:' + sectionMiddlePercent,
                    })
                })
            }, 100)
        }
    }))

    // Position the #scroller according to the current scroll position of the page
    ScrollTrigger.create({
        trigger: '#main',
        start: 'top top',
        onUpdate: (self) => {
            let percent = self.progress * 100 + '%'
            let direction = self.direction === 1 ? 'down' : 'up'
            let rotate = direction === 'down' ? 5 : -5

            gsap.to('#scroller', {
                top: percent,
                ease: 'back',
                duration: 2,
            })

            gsap.to('#submarine', {
                duration: 2,
                rotate: rotate,
            })
        }
    })

    // autostart music #music
    let audio = new Audio('/audio/underwater-ambience.mp3')
    document.getElementById('submarine').addEventListener('click', function () {
        // toggle audio
        if (audio.paused) {
            audio.play()
        } else {
            audio.pause()
        }
    }, false)
}

Alpine.start()
